import { combineReducers } from 'redux';
import message from 'antd/lib/message';
import { call, put, takeLatest } from 'redux-saga/effects';
import { t } from '../../../app/i18n';
import landingPageApi from '../api';
import {
  createApiActionCreators,
  createReducer,
  createActionType,
  REQUEST,
  SUCCESS,
  FAILURE,
} from '../../../common/utils/reduxHelpers';

/**
 * ACTION TYPES
 */
export const SUBSCRIBE = 'landingPage/SUBSCRIBE';

/**
 * ACTIONS
 */
export const subscribeActions = createApiActionCreators(SUBSCRIBE);

/**
 * REDUCERS
 */
const initialState = {
  isSubscribing: false,
};

const isSubscribing = createReducer(initialState.isSubscribing, {
  [SUBSCRIBE]: {
    [REQUEST]: state => true,
    [SUCCESS]: state => false,
    [FAILURE]: state => false,
  },
});

export default combineReducers({
  isSubscribing,
});

/**
 * SELECTORS
 */
export const selectLandingPage = state => state.landingPage;

export const selectIsSubscribing = state => selectLandingPage(state).isSubscribing;

/**
 * SAGAS
 */
function* subscribe(action) {
  const { email } = action.payload;
  const resp = yield call(landingPageApi.subscribe, email);

  if (resp.ok) {
    yield put(subscribeActions.success(resp.data));

    message.success(t('E-mail bol úspešne pridaný do newslettera'), 3);
  } else {
    yield put(subscribeActions.failure(resp.error));
  }
}

export function* landingPageSaga() {
  yield takeLatest(createActionType(SUBSCRIBE, REQUEST), subscribe);
}



// WEBPACK FOOTER //
// ./src/features/landing-page/ducks/index.js